import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  Outlet, useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import TaskBasesList from './TaskBasesList'
import {useGetCoursesQuery} from "../courses/coursesApiSlice"
import { Button } from "@mui/material"
import TaskBaseExporter from "./TaskBaseExporter"
import { useDeleteMultiTaskBaseMutation } from "./taskBasesApiSlice"
import { use } from "react"
function TaskBasesListFilter() {
    const {groupId, type} = useParams()
    useTitle('geshtop-Exercise: TaskBases List')
    const [active,setActive] = useState(false)
    const [course,setCourse] = useState('')
    const [selected, setSelected] = useState([])
    const [showModal,setShowModal] = useState(false)
    const [q,setQ] = useState('')
    const [deleteMultiTaskBase, {isSuccess}] = useDeleteMultiTaskBaseMutation()
    const { courses , } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            courses: data?.ids.map(id => data?.entities[id])
        }),
    })
    const handleImportFromGroupClick = ()=>{
        navigate(`/${type}/${groupId}/task-bases/list/import`)
    }
    const handleExportSelectedClick = ()=>{
        if(selected.length){
            setShowModal(true)
        }
    }
    const handleDeleteSelectedClick = ()=>{
        if(selected.length){
            if(window.confirm("האם אתה בטוח שברצונך למחוק את הנבחרים?")){
                deleteMultiTaskBase({selected})
            }
        }
    }
    useEffect(()=>{
        if(isSuccess){
            setSelected([])
        }
    },[isSuccess])

    const navigate = useNavigate()
    if(!courses) return <PulseLoader color={"#fff"} />
    const content =(<>
    <div className="filter-form">
        <h2> משימות בסיס </h2>
        <div >
        <Button color="primary" variant="contained" onClick={handleImportFromGroupClick} >ייבוא מקבוצה</Button>
        <Button style={{marginRight:"10px", opacity: selected.length ===0? "0.4 ": "1"}}  color={selected.length ===0? "info": "primary"} variant="contained" onClick={handleExportSelectedClick} >ייצוא  {selected.length} נבחרים</Button>
        <Button style={{marginRight:"10px", opacity: selected.length ===0? "0.4 ": "1"}}  color={selected.length ===0? "info": "error"} variant="contained" onClick={handleDeleteSelectedClick} >מחיקה מרובה  {selected.length} נבחרים</Button>

        </div>
        {/* <div className="filter-form-item">
        <label className="form__label form__checkbox-container" htmlFor="active">
                    משימות בתוקף:
                    <input
                        className="form__checkbox"
                        id="active"
                        name="active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                    </label>
                    </div> */}
                    <div className="filter-form-item">

                    
                <select
                    id="course"
                    name="course"
                    className={`form__select `}
                    value={course}
                    onChange={(e)=>setCourse(e.target.value)}
                >
                   <option value="">---בחר קורס ---</option>
                   {courses.map((c)=>{
                    return <option key={c._id} value={c._id}>{c.name}</option>
                   })}
                   
                </select>

        </div>
        <div className="filter-form-item">
            <input className="form__input" placeholder="הכנס מילה לחיפוש" onChange={(e)=>setQ(e.target.value)} />
            </div>
    </div>
 <TaskBasesList  q={q} active={active} course={course} selected={selected} setSelected={setSelected} />
 {showModal && <TaskBaseExporter setShowModal={setShowModal} selected={selected} /> }
 <Outlet />
</> ) 
  return content;
}

export default TaskBasesListFilter